var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SetTag',{class:{'box-loading': _vm.loading},attrs:{"type":"candidate","enable":_vm.permissions.includes('manage_candidates'),"dark":true,"value":_vm.candidate.tags},on:{"input":_vm.updateTags}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7132da16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Candidate/Header/CandidateTag.vue
// module id = null
// module chunks = 